import FixedTopNotification from 'components/FixedTopNotification/FixedTopNotification'
import { useState } from 'react'
import { assumeAllowedRules, checkSameSectorAndLocation } from '../../NotificationsTreatmentsSteps/Header/Children/Buttons/AssumeTreatment'
import { UserDataType } from 'types/autentication'
import WithRoleAuthorization from 'components/WithRoleAuthorization/WithRoleAuthorization'
import ExclamationIcon from 'components/Icons/ExclamationIcon'

export interface GroupData {
    group_key: string
    group_info: {
        u_notifica_user: { value: string; display_value: string }
        u_number: { value: string; display_value: string }
        u_related_notifications: { value: string; display_value: string }
        u_sector: { value: string; display_value: string }
        u_incident_type: { value: string; display_value: string }
        u_group_damage_rating: { value: string; display_value: string }
        u_location: { value: string; display_value: string }
        u_assigned_to: { value: string; display_value: string }
        sys_id: { value: string; display_value: string }
    }
    total_notifications: number
    notifications: any[]
}

export interface IGroupAssumeTreatmentInfo {
    currentUser: UserDataType
    groupData: GroupData | null
    handleAssumeGroupTreatment: () => void
}

export default function GroupAssumeTreatmentInfo({ 
    handleAssumeGroupTreatment,
    currentUser,
    groupData
}: IGroupAssumeTreatmentInfo) {
    const [showAssumeGroupInfo, setShowAssumeGroupInfo] = useState(true)

    // Verificar se o usuário logado é o responsável pelo grupo
    const loggedInUserIsResponsible = 
        currentUser?.sys_id === groupData?.notifications?.[0]?.u_assigned_to?.value

    // Verificar se o grupo está finalizado
    const isGroupFinalized = groupData?.notifications?.[0]?.u_state?.value === '5'

    // Verificar se deve mostrar o alerta
    // Não mostrar se não houver dados, se o usuário for responsável, ou se o grupo estiver finalizado
    if (!groupData || loggedInUserIsResponsible || isGroupFinalized) {
        return null
    }

    // Obter localização e setor da primeira notificação do grupo
    const notificationLocation = groupData?.notifications?.[0]?.location_incident?.value
    const notificationSector = groupData?.notifications?.[0]?.incident_sector?.value

    const { isSameLocation, isSameSector } = checkSameSectorAndLocation({
        currentUser,
        notificationLocation: notificationLocation || '',
        notificationSector: notificationSector || ''
    })

    return (
        <WithRoleAuthorization
            allowedRoles={assumeAllowedRules({ isSameLocation, isSameSector })}
            userRole={currentUser?.profile}
            children={
                <FixedTopNotification
                    show={showAssumeGroupInfo}
                    handleClose={() => {
                        setShowAssumeGroupInfo(false)
                    }}
                >
                    <div className="flex items-center w-full text-center justify-center"
                        data-testid="test-assume-group-treatment-info"
                    >
                        <div className="mr-1">
                            <ExclamationIcon />
                        </div>
                        <span className="text-sm font-bold">
                            Esse grupo de notificações está em tratamento por outra
                            pessoa. Para editar esse grupo você precisa{' '}
                            <span
                                onClick={handleAssumeGroupTreatment}
                                className="text-blueTheme underline cursor-pointer">
                                assumir o tratamento
                            </span>{' '}
                            dele.
                        </span>
                    </div>
                </FixedTopNotification>
            }
        />
    )
}

export { GroupAssumeTreatmentInfo }
